import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';
import {LangSrc} from '../../interfaces/lang-src';
import { User } from 'src/app/interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  me() {
    return this.toolsSrv.withTimeout(
      this.http.get(`${this.toolsSrv.getApiEndpoint()}user/me`),
      10000,
      1
    ).toPromise();
  }

  age() {
    return this.http.get(`${this.toolsSrv.getApiEndpoint()}user/me/age`).toPromise();
  }

  async currentLevel(targetLanguage?: string) {
    if (targetLanguage) {
      return this.http.get(`${this.toolsSrv.getApiTargetEndpoint(targetLanguage)}levels/me`, {
        headers: new HttpHeaders({ Platform: targetLanguage })
      }).toPromise();
    }
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}levels/me`).toPromise();
  }

  details() {
    return this.http.get(`${this.toolsSrv.getApiEndpoint()}user/details`).toPromise();
  }

  updateProfile(params: any) {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/update-profile`, params);
  }

  updateDetails(params: any) {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/update-details`, params);
  }

  updatePassword(params: any) {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/update-password`, params);
  }

  updateAccessibility(params: any) {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/update-accessibility`, params);
  }

  updateLanguage(lang: LangSrc) {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/update-language`, {
      language: lang.id
    }).toPromise();
  }

  emailExist(mail: string): Promise<any> {
    return this.http.get(`${this.toolsSrv.getApiEndpoint()}user/check-mail/${mail}`).toPromise();
  }

  checkForm(url: string): Promise<any> {
    return this.http.post(`${this.toolsSrv.getApiEndpoint()}user/check-form`, {
      form: url
    }).toPromise();
  }

  async hasActiveDebit(): Promise<boolean> {
    const result: any = await this.http.get(`${this.toolsSrv.getApiEndpoint()}user/debit`).toPromise();
    return result?.active === true;
  }

  unsubscribeConfirmed() {
    return this.http.patch(`${this.toolsSrv.getApiEndpoint()}user/unsubscribe`, null).toPromise();
  }

  deleteAccount() {
    return this.http.delete(`${this.toolsSrv.getApiEndpoint()}user/delete`).toPromise();
  }
}
